var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMissionEleven(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 47,
    viewBox: "0 0 72 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91618 28.9793C14.9392 24.4834 8.69325 11.7079 4.97278 6.70967C10.3729 5.15686 22.8542 3.28032 34.5756 8.4986M8.91618 28.9793C0.0699386 30.907 0.540632 12.9216 4.54361 13.8115C8.54659 14.7014 8.14561 23.0361 7.74064 23.7892M8.91618 28.9793L37.176 21.5506M34.5756 8.4986C40.0102 5.24154 54.5873 0.610226 64.3547 2.13357C68.4391 8.19063 74.1133 19.9467 64.201 24.2205L37.176 21.5506M34.5756 8.4986C36.7384 10.0981 40.2864 14.9477 37.176 21.5506M37.176 21.5506C35.4029 22.5666 32.11 28.9035 33.1235 46.1233M37.176 21.5506C36.9698 26.0956 37.9843 36.3863 43.6919 41.1893",
    stroke: "white",
    strokeWidth: 2.64764
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissionEleven);
export default __webpack_public_path__ + "static/media/iconMissionEleven.96eba0362d0ae2aaaaa79ab5da0535ac.svg";
export { ForwardRef as ReactComponent };